import _extends from 'babel-runtime/helpers/extends';

import create from '../utils/create';
import { isObj } from '../utils';

export default create({
  render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('cell', { class: _vm.b({
        error: _vm.error,
        disabled: _vm.$attrs.disabled,
        'has-icon': _vm.showIcon,
        'min-height': _vm.type === 'textarea' && !_vm.autosize
      }), attrs: { "icon": _vm.leftIcon, "title": _vm.label, "center": _vm.center, "border": _vm.border, "required": _vm.required } }, [_vm._t("label", null, { slot: "title" }), _vm.type === 'textarea' ? _c('textarea', _vm._g(_vm._b({ ref: "input", class: _vm.b('control'), domProps: { "value": _vm.value } }, 'textarea', _vm.$attrs, false), _vm.listeners)) : _c('input', _vm._g(_vm._b({ ref: "input", class: _vm.b('control'), attrs: { "type": _vm.type }, domProps: { "value": _vm.value } }, 'input', _vm.$attrs, false), _vm.listeners)), _vm.errorMessage ? _c('div', { class: _vm.b('error-message'), domProps: { "textContent": _vm._s(_vm.errorMessage) } }) : _vm._e(), _vm.showIcon ? _c('div', { class: _vm.b('icon'), on: { "touchstart": function touchstart($event) {
          $event.preventDefault();return _vm.onClickIcon($event);
        } } }, [_vm._t("icon", [_c('icon', { attrs: { "name": _vm.icon } })])], 2) : _vm._e(), _vm.$slots.button ? _c('div', { class: _vm.b('button'), attrs: { "slot": "extra" }, slot: "extra" }, [_vm._t("button")], 2) : _vm._e()], 2);
  },

  name: 'field',

  inheritAttrs: false,

  props: {
    value: [String, Number],
    icon: String,
    label: String,
    error: Boolean,
    center: Boolean,
    leftIcon: String,
    required: Boolean,
    onIconClick: Function,
    autosize: [Boolean, Object],
    errorMessage: String,
    type: {
      type: String,
      default: 'text'
    },
    border: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    value: function value() {
      this.$nextTick(this.adjustSize);
    }
  },

  mounted: function mounted() {
    this.$nextTick(this.adjustSize);
  },


  computed: {
    showIcon: function showIcon() {
      return this.$slots.icon || this.icon && this.value !== '' && this.isDef(this.value);
    },
    listeners: function listeners() {
      return _extends({}, this.$listeners, {
        input: this.onInput,
        keypress: this.onKeypress
      });
    }
  },

  methods: {
    blur: function blur() {
      this.$refs.input && this.$refs.input.blur();
    },
    onInput: function onInput(event) {
      this.$emit('input', event.target.value);
    },
    onClickIcon: function onClickIcon() {
      this.$emit('click-icon');
      this.onIconClick && this.onIconClick();
    },
    onKeypress: function onKeypress(event) {
      if (this.type === 'number') {
        var keyCode = event.keyCode;

        var allowPoint = String(this.value).indexOf('.') === -1;
        var isValidKey = keyCode >= 48 && keyCode <= 57 || keyCode === 46 && allowPoint || keyCode === 45;
        if (!isValidKey) {
          event.preventDefault();
        }
      }
      this.$emit('keypress', event);
    },
    adjustSize: function adjustSize() {
      var input = this.$refs.input;

      if (!(this.type === 'textarea' && this.autosize) || !input) {
        return;
      }

      input.style.height = 'auto';

      var height = input.scrollHeight;
      if (isObj(this.autosize)) {
        var _autosize = this.autosize,
            maxHeight = _autosize.maxHeight,
            minHeight = _autosize.minHeight;

        if (maxHeight) {
          height = Math.min(height, maxHeight);
        }
        if (minHeight) {
          height = Math.max(height, minHeight);
        }
      }

      if (height) {
        input.style.height = height + 'px';
      }
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/field/index.js
// module id = 12
// module chunks = 39